import React from 'react';
import styled from 'styled-components';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import TemplateList from '../templates/TemplateList';

const TemplateDialog = styled(Dialog)`
  .MuiDialog-paper {
    max-width: 900px;
    width: 90vw;
  }
`;

const TemplateSelector = ({ open, onClose, onSelect, userSubscription }) => {
  const handleTemplateSelect = (template) => {
    if (template.isPremium && userSubscription !== 'premium') {
      alert('此模板需要升级到高级会员才能使用');
      return;
    }
    onSelect(template);
    onClose();
  };

  return (
    <TemplateDialog open={open} onClose={onClose}>
      <DialogTitle>选择简历模板</DialogTitle>
      <DialogContent>
        <TemplateList onSelectTemplate={handleTemplateSelect} />
      </DialogContent>
    </TemplateDialog>
  );
};

export default TemplateSelector; 